export const SET_CART = "SET_CART"
export const CLEAR_CART = "CLEAR_CART"
export const ADD_CART_ITEM = "ADD_CART"
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM"
